import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

/**
 * Verifica que el token JWT exista y no haya expirado.
 * @param {string} token
 * @returns {boolean}
 */
const isTokenValid = (token) => {
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp != null && decoded.exp > currentTime;
  } catch {
    return false;
  }
};

/**
 * Componente que protege rutas según autenticación y rol.
 *
 * No inyecta roles adicionales: usa exactamente los allowedRoles
 * que se le pasan. Si el array está vacío, nadie puede acceder.
 *
 * @param {React.ReactNode} children  - Contenido a renderizar si el acceso es válido
 * @param {string[]}        allowedRoles - Lista de roles con acceso a esta ruta
 */
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const role  = localStorage.getItem('role')  || sessionStorage.getItem('role');

  // Sin sesión válida → login
  if (!token || !role || !isTokenValid(token)) {
    return <Navigate to="/login" replace />;
  }

  // Rol no autorizado para esta ruta → página de acceso denegado
  if (!allowedRoles.includes(role)) {
    return <Navigate to="/no-autorizado" replace />;
  }

  return children;
};

export default ProtectedRoute;
